import { RouterProvider } from 'react-router-dom'
import { Loading } from '@/components/loading'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './api/react-query'
import { router } from './router'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { ToastContainer } from 'react-toastify'
import { theme } from './styles/theme'
import './styles/global.css'
import { env, envUrlByService } from './env'
import { StatusBar, Style } from '@capacitor/status-bar'

import TagManager from 'react-gtm-module'
import { useEffect } from 'react'
import { usePlatform } from './hooks'
import { GoogleOAuthProvider } from '@react-oauth/google'

import * as Sentry from '@sentry/react'
import { ErrorPage } from '@/pages/error/error.page'

import { ApiError } from './api/http-client'

const tagManagerArgs = {
  gtmId: 'GTM-5KQ368ZB',
}

if (env.MODE === 'production') {
  TagManager.initialize(tagManagerArgs)

  Sentry.init({
    dsn: 'https://5c2324190f9ac8baf6de43cb5cfb956e@o349918.ingest.us.sentry.io/4509865185050624',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.5,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: [
      envUrlByService['accounting-dealer'].production,
      envUrlByService['user-manager'].production,
      envUrlByService.financial.production,
    ],
    ignoreErrors: [],
    beforeSend(event, hint) {
      if (hint.originalException instanceof ApiError) {
        return null
      }
      return event
    },
  })
}

export function App() {
  const { isAndroid } = usePlatform()

  useEffect(() => {
    const configureStatusBar = async () => {
      if (isAndroid) {
        await StatusBar.setStyle({ style: Style.Light })
        await StatusBar.setBackgroundColor({ color: '#ffffff' })
        await StatusBar.setOverlaysWebView({ overlay: false })
      }
    }

    configureStatusBar()
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <GoogleOAuthProvider clientId="958013636463-8mpjlrua7imvfnm8b02cs012rkn35u84.apps.googleusercontent.com">
        <QueryClientProvider client={queryClient}>
          <Sentry.ErrorBoundary fallback={<ErrorPage />}>
            <RouterProvider router={router} fallbackElement={<Loading />} />
          </Sentry.ErrorBoundary>
        </QueryClientProvider>
      </GoogleOAuthProvider>

      <ToastContainer
        position="bottom-center"
        hideProgressBar
        closeOnClick
        limit={3}
        icon={false}
        closeButton={false}
        style={{ padding: '0 16px' }}
        toastStyle={{
          padding: 0,
          width: '100%',
          minHeight: 'auto',
          borderRadius: 16,
          marginBottom: 16,
        }}
      />
      <CssBaseline />
    </ThemeProvider>
  )
}
